<template>
    <v-container fluid grid-list-md class="pa-0">
      <v-layout row wrap class="">
        <v-flex lg6 sm6 xs12 class="">
          <v-card class="pa-2 card-r grey lighten-4">
            <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-17 text-capitalize">active students</div>
            </v-toolbar>
            <v-list tow-line class="pa-0 transparent" style="height: 65vh!important; overflow-y: scroll">
             <!-- <template v-for="(item, index) in TeacherStudentData[0].active_students">-->
              <div v-for="(i,index3) in TeacherStudentData.length " v-bind:key="index3">
                <div v-for="(item, index) in TeacherStudentData[index3].active_students" >
                  <div v-for="(item1, index1) in TeacherStudentData[index3].active_students[index].class_details">

                <v-list-tile class="shadow-1 card-r white mt-2 pa-1"
                        :key="item.name"
                        avatar
                        @click=""
                >
                  <v-list-tile-avatar>
                    <v-avatar color="blue-grey lighten-4">
                     <img :src="item.image" class="objec-fit">
                    </v-avatar>
                  </v-list-tile-avatar>


                  <v-list-tile-content class="pa-0 f-12">
                    <v-list-tile-title class="pa-0 f-13 font-weight-bold" v-html="item.name"></v-list-tile-title>
                    <!--<v-list-tile-sub-title class=" pb-3 f-10 pa-2" v-html="item.package_name"></v-list-tile-sub-title>-->
                    <v-list-tile-sub-title class="text-grey pa-0 f-12" v-html="item1.name"></v-list-tile-sub-title>
                   <!-- <v-list-tile-sub-title class=" pb-3 f-10 pa-2" v-html="item1.description"></v-list-tile-sub-title>-->
                    <v-list-tile-sub-title class="text-grey pa-0 f-12" v-html="item1.date"></v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <!--<v-btn icon class="ma-0 text-primary no-shadow"><v-icon>fas fa-comment-alt</v-icon></v-btn>-->
                  </v-list-tile-action>
                </v-list-tile>
              </div>
                </div>
              </div>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex lg6 sm6 xs12 class="">
          <v-card class="pa-2 card-r grey lighten-4">
            <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-17 text-capitalize">pending students</div>
            </v-toolbar>
            <v-list tow-line v-if="TeacherStudentData[0]" class="pa-0 transparent" style="height: 65vh!important; overflow-y: scroll">
              <template v-for="(item, index) in TeacherStudentData[0].pending_students" >

                <v-list-tile class="shadow-1 card-r white mt-2 pa-1"
                        :key="index"
                        avatar
                        @click=""
                >
                  <v-list-tile-avatar>
                    <v-avatar color="blue-grey lighten-4">
                     <img :src="item.image" class="objec-fit">
                    </v-avatar>
                  </v-list-tile-avatar>

                  <v-list-tile-content class="pa-0 f-12">
                    <v-list-tile-title class="pa-0 f-13 font-weight-bold" v-html="item.name"></v-list-tile-title>
                    <v-list-tile-sub-title class="text-grey pa-0 f-12" v-html="item.package_name"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>
<script>
    /* eslint-disable */
    import { mapState, dispatch } from "vuex";

    export default {
        name: "Students",
        data () {
            return {
                items: [
                    // { header: 'ACTIVE STUDENTS', header1: 'PENDING STUDENTS' },
                    {
                        avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
                        title1: 'student name',
                        title: 'Not Booked',
                        subtitle: "<span class='text--primary'>address, package name , </span> &mdash; some describtions for this class or somthig..."
                    },
                    { divider: true, inset: true },

                ],
            }
        },
        props:['id'],
        created() {
            // this.TeacherStudentData=''
            this.teacherId = this.$route.params.id;
            Store.state.Teachers.TeacherStudentData=[]
            Store.dispatch("Teachers/getTeacher_studentById", this.teacherId).then(res => {
            });

        },
        computed: {
            ...mapState({
                TeacherStudentData: TeacherStudentData => Store.state.Teachers.TeacherStudentData
    })
    },
    }

</script>



// WEBPACK FOOTER //
// src/components/profile/teacher/Students.vue